import { DishCategory } from '../index';

class DishCategoryArrayField {

  readonly list: DishCategory[];
  readonly object?: DishCategory;
  readonly dirt?: DishCategory;
  readonly index: number;
  readonly dirty: boolean;
  readonly ok: boolean;
  readonly error: string;

  constructor(list: DishCategory[], object?: DishCategory) {
    this.list = list;
    this.object = object;
    this.index = object && list.find(it => it.id === object.id) ? list.findIndex(it => it.id === object.id) : 0;
    this.dirty = false;
    this.ok = this.check(this.index);
    this.error = this.getError(this.index);
  }

  change(index: number): this {
    const object = this.list[index];
    const dirt = object;
    const dirty = true;
    const ok = this.check(index);
    const error = this.getError(index);
    return Object.assign(Object.create(this.constructor.prototype), { ...this, index, object, dirt, dirty, ok, error });
  }

  private check(index: number): boolean {
    if (!this.list[index]) return false;
    return true;
  }

  private getError(index: number): string {
    if (!this.list[index]) return 'must be in the list';
    return '';
  }

}

export { DishCategoryArrayField };